<template>
  <footer class="bg-[var(--forest)] text-[var(--cream)] pt-16 pb-10 px-6">
    <div class="max-w-6xl mx-auto fade-in-content">
      <div class="grid lg:grid-cols-2 gap-8 mb-10">
        <!-- Left Column: Brand & Description -->
        <div class="space-y-4">
          <div class="space-y-2">
            <img src="/images/safe_haven_logo_clear.png" alt="Safe Haven Wellness Group" class="h-32 w-auto object-contain" />
          </div>
          <p class="text-sm text-[var(--sage)] italic leading-relaxed max-w-lg">
            Empowering individuals through shared wisdom and compassionate care. A safe, inclusive space for healing and leadership.
          </p>
        </div>
        
        <!-- Right Column: Links & Newsletter -->
        <div class="grid md:grid-cols-2 gap-8">
          <div class="space-y-3">
            <div class="space-y-2">
              <h6 class="text-[var(--terracotta)] font-bold uppercase tracking-[0.2em] text-xs">Navigation</h6>
              <ul class="flex flex-col gap-2 text-[var(--sage)] font-medium">
                <li><router-link to="/#story" class="hover:text-[var(--terracotta)] italic transition-colors text-sm">Our Story</router-link></li>
                <li><router-link to="/interventions" class="hover:text-[var(--terracotta)] italic transition-colors text-sm">Interventions</router-link></li>
                <li><router-link to="/about" class="hover:text-[var(--terracotta)] italic transition-colors text-sm">About Us</router-link></li>
                <li><router-link to="/case-studies" class="hover:text-[var(--terracotta)] italic transition-colors text-sm">News, Reports & Media</router-link></li>
              </ul>
            </div>
          </div>
          <div class="space-y-3">
            <div class="space-y-2">
              <h6 class="text-[var(--terracotta)] font-bold uppercase tracking-[0.2em] text-xs">Connect</h6>
              <ul class="flex flex-col gap-2 text-[var(--sage)] font-medium">
                <li><a class="hover:text-[var(--terracotta)] italic transition-colors text-sm" href="#">Contact Us</a></li>
                <li><a class="hover:text-[var(--terracotta)] italic transition-colors text-sm" href="#">Find a Specialist</a></li>
                <li><router-link to="/join" class="hover:text-[var(--terracotta)] italic transition-colors text-sm">Join Community</router-link></li>
                <li><a class="hover:text-[var(--terracotta)] italic transition-colors text-sm" href="#">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Copyright -->
      <div class="pt-8 border-t border-[var(--moss)]/30 text-center">
        <p class="text-xs text-[var(--sage)] italic">© {{ new Date().getFullYear() }} All rights reserved. Designed and developed by <a href="https://sitati.vercel.app" target="_blank" class="text-[var(--terracotta)] hover:text-[var(--terracotta)]/90 transition-colors">Sitati</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'AppFooter',
  setup() {
    const setupFadeIn = () => {
      const contentElements = document.querySelectorAll('.fade-in-content')
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.classList.contains('fade-in-visible')) {
            entry.target.classList.add('fade-in-visible')
            observer.unobserve(entry.target)
          }
        })
      }, {
        rootMargin: '-10% 0px -10% 0px',
        threshold: 0.1
      })

      contentElements.forEach((content) => {
        observer.observe(content)
      })
    }

    onMounted(() => {
      setupFadeIn()
    })
  }
}
</script>

<style scoped>
.fade-in-content {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-content.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}
</style>
